<template>
    <el-dialog
            :visible="detailDialogVisible"
            title="海报详情"
            width="1000px"
            @open="openDialog"
            @close="closeDialog"
    >
        <el-form :model="posterDetail" ref="posterForm" class="poster-form" :rules="rules" label-width="200px">
            <el-form-item label="标题：" prop="title">
                <el-input :value="posterDetail.title" @change="handleFormChange('title', $event)"></el-input>
            </el-form-item>
            <el-form-item label="图片：" prop="posterUrl">
                <upload :value="posterDetail.posterUrl" @change="handleFormChange('posterUrl', $event)"></upload>
            </el-form-item>
            <el-form-item label="序号">
                <el-input-number :value="posterDetail.orderNum" :min="1" :max="10000000" @change="handleOrderNumChange($event)"
                                 label="序号"></el-input-number>
            </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
      <el-button @click="toggleDetailDialogVisible(false)">取消</el-button>
      <el-button type="primary" @click="handleSave('posterForm')">保存</el-button>
    </span>
    </el-dialog>
</template>

<script>
    import {mapState, mapGetters, mapActions, mapMutations} from 'vuex';
    import Upload from 'components/upload';

    export default {
        name: 'posterDetail',
        props: ['value'],
        data() {
            return {
                rules: {
                    title: [{required: true, message: '标题不能为空！'}],
                    imageUrl: [{required: true, message: '图片不能为空！'}]
                }
            };
        },
        components: {
            Upload
        },
        computed: {
            ...mapState('posterSetting', [
                'detailDialogVisible'
            ]),
            ...mapGetters('posterSetting', ['posterDetail', 'posterList'])
        },
        methods: {
            ...mapActions('posterSetting', ['detail', 'update', 'list', 'setDetail']),
            ...mapMutations('posterSetting', [
                'toggleDetailDialogVisible',
                'setPosterDetail'
            ]),
            openDialog() {
                this.detail(this.value);
            },
            closeDialog() {
                this.toggleDetailDialogVisible(false);
            },
            handleFormChange(type, value) {
                this.setPosterDetail({
                    ...this.posterDetail,
                    [type]: value
                });
            },
            handleOrderNumChange(value) {
                this.setPosterDetail({
                    ...this.posterDetail,
                    ["orderNum"]: value
                });
            },
            handleSave(formName) {
                this.$refs[formName].validate(valid => {
                    if (valid) {
                        this.update(this.posterDetail).then(() => {
                            this.$message({
                                message: '修改成功！',
                                type: 'success'
                            });
                            this.toggleDetailDialogVisible(false);
                            this.$emit('refresh');
                        });
                    }
                });
            }
        }
    };
</script>

<style lang="less" scoped>
    .poster-form {
        margin-right: 100px;
    }
</style>
